<template>
  <div class="w-100 h-100 m-0" style="padding: 32px">
    <div class="row m-0 p-0 acry-page-title justify-content-center">注文履歴</div>
    <div class="row" style="margin: 40px;">
        <div class="p-0 align-self-center text-center" style="height:48px">
          <form class="h-100 w-100 d-flex justify-content-center">
            <span class="h-100 acry-text-title my-auto" style="padding: 10px;">期間</span>
            <input class="input-field acry-text-title" style="width:178px; padding-left: 60px;" type="date" v-model="fromDate" />
            <span class="h-100 acry-text-title my-auto" style="padding: 10px;">〜</span>
            <input class="input-field acry-text-title" style="width:178px; padding-left: 60px;" type="date" v-model="toDate" />
            <div class="position-relative ms-1">
              <input class="input-field" style="padding-left: 15px;" type="text" v-model="findOrderId" placeholder="注文IDで検索" />
              <!-- <i class="bi bi-search position-absolute" style="top:11px;left:17px"></i> -->
            </div>
            <span class="input-group-btn my-auto">
              <button type="button" class="bg-transparent border-0" @click="findAction">
                <img
                  src="@/assets/acrypro/search.svg"
                  class=""
                  style="width: 35px; height: 35px"
                />
              </button>
            </span>
          </form>

        </div>
    </div>

    <div class="justify-content-center m-auto" style="height:680px; width:90%">
      <div class="d-flex text-start" style="padding-right: 15px; font-size:15px;">
        <div class="" style="width:20%;">注文日</div>
        <div class="" style="width:14%;">注文ID</div>
        <div class="" style="width:13%;">送料</div>
        <div class="" style="width:13%;">消費税</div>
        <div class="" style="width:13%;">金額</div>
        <div class="" style="width:10%;">ステータス</div>
        <div class="" style="width:10%;"></div>
      </div>

      <hr class="mt-0 mb-1">

      <div class="scroll" style="height:660px; padding-right: 15px; font-size:15px;">
        <div v-for="(ld, index) in this.listData"
          v-bind:key="ld['order_id']" class="cell-border">
          <!-- 注文概要 -->
          <div class="d-flex text-start cell">
            <div class="m-auto" style="width:19%;">{{ ld["create_date"] }}</div>
            <div class="m-auto" style="width:12%;">{{ ld["order_id"] }}</div>
            <div class="m-auto" style="width:12%;">{{ ld["deliv_fee_base"] }}円</div>
            <div class="m-auto" style="width:12%;">{{ parseInt(ld["tax"]) + parseInt(ld["deliv_fee_tax"]) }}円</div>
            <div class="m-auto" style="width:12%;">{{ ld["payment_total"] }}円</div>
            <div class="m-auto" style="width:12%;">{{ ld["status_name"] }}</div>
            <div class="m-auto h-100" style="width:13%;">
              <div class="h-50">
                <button class="w-100 acry-btn-secondary-normal btn-size" @click="receipt(ld['order_id'])" :class="{'disable-ui':!(ld['status'] == 5)}">領収書発行</button>
              </div>
              <div class="h-50">
                <button class="w-100 acry-btn-primary-normal btn-size mt-1" @click="cellDetail(index)">詳細</button>
              </div>
            </div>
          </div>

          <!-- 注文詳細 -->
          <div v-if="listDataDetail[index] && !isTicketOrder(index)" class="w-100 border-dashed order-detail">
            <div class="w-100 d-flex p-4 pb-1" style="font-size: 15px;">
              <div class="text-start ps-1" style="width:15%">配送先</div>
              <div class="text-start" style="width:85%">{{getShippingAddr(index)}}</div>
            </div>
            <div class="w-100 d-flex p-4 pt-1" style="font-size: 15px;">
              <div class="text-start ps-1" style="width:15%">TEL</div>
              <div class="text-start" style="width:85%">{{getShippingTel(index)}}</div>
            </div>

            <div style="width:35%"></div>
            <div class="d-flex flex-column border-dashed" style="">
              <div class="w-100 d-flex">
                <div class="my-1" style="width:15%">デザイン</div>
                <div class="my-1" style="width:15%">サイズ</div>
                <div class="my-1" style="width:20%">個数</div>
                <div class="my-1" style="width:30%">金額</div>
                <div class="my-1" style="width:50%"></div>
              </div>
              <!-- 注文商品 アクリル -->
              <div v-for="(p, index) in listDataDetailData[index].acrylProducts" :key="index" class="w-100 d-flex border-dashed detail-cell">
                <div class="" style="width:15%"><img :src="p.previewImageUrl" class="img-fluid bg-secondary h-100" @click="imagePopup(p.previewImageUrl)"/></div>
                <div class="my-auto" style="width:15%"><span style="font-size:14px;">アクリルプレート</span><br>{{ getSize(p.productId) }}</div>
                <div class="my-auto" style="width:20%">{{ p.quantity }}</div>
                <div class="my-auto" style="width:30%">{{ p.price }}円</div>
                <div class="my-1" style="width:30%"></div>
                <div class="d-flex flex-column justify-content-center" style="width:20%">
                  <div class="m-1" style="height:24px;">
                    <p class="link-text" @click="imagePopup(p.previewImageUrl)" style="cursor: pointer;">プレビュー</p>
                  </div>
                  <div class="m-1" style="height:24px;">
                    <p class="link-text" @click="reorderDesign(p)" style="cursor: pointer;">再注文</p>
                  </div>
                </div>
              </div>
              <!-- 注文商品 サンプル -->
              <div v-for="(p, index) in listDataDetailData[index].sampleProducts" :key="index" class="w-100 d-flex border-dashed detail-cell">
                <div class="" style="width:15%"><img :src="p.previewImageUrl" class="img-fluid bg-secondary h-100" @click="imagePopup(p.previewImageUrl)"/></div>
                <div class="my-auto" style="width:15%"><span style="font-size:14px;">アクリルプレート</span><br>{{ getSize(p.productId) }}</div>
                <div class="my-auto" style="width:20%">{{ p.quantity }}</div>
                <div class="my-auto" style="width:30%">{{ p.price }}円</div>
                <div class="my-1" style="width:30%"></div>
                <div class="d-flex flex-column justify-content-center" style="width:20%">
                  <div class="m-1" style="height:24px;">
                    <p class="link-text" @click="imagePopup(p.previewImageUrl)" style="cursor: pointer;">プレビュー</p>
                  </div>
                  <!-- <div class="m-1" style="height:24px;">
                    <p class="link-text" @click="reorderDesign(p)" style="cursor: pointer;">再注文</p>
                  </div> -->
                </div>
              </div>
              <!-- 注文商品 オプション -->
              <div v-for="(p, index) in listDataDetailData[index].optionProducts" :key="index" class="w-100 d-flex border-dashed detail-cell">
                <div class="" style="width:15%"><img :src="p.designImageUrl" class="img-fluid bg-secondary h-100" @click="imagePopup(p.designImageUrl)"/></div>
                <div class="my-auto" style="width:15%">{{ getSize(p.productId) }}</div>
                <div class="my-auto" style="width:20%">{{ p.quantity }}</div>
                <div class="my-auto" style="width:30%">{{ p.price }}円</div>
                <div class="my-1" style="width:30%"></div>
                <div class="d-flex flex-column justify-content-center" style="width:20%">
                  <div class="m-1" style="height:24px;">
                    <p class="link-text" @click="imagePopup(p.designImageUrl)">プレビュー</p>
                  </div>
                  <div class="m-1" style="height:24px;">
                    <p class="link-text" @click="reorderOption(p)">再注文</p>
                  </div>
                </div>
              </div>
              <!-- 注文商品 アクリープリント -->
              <div v-for="(p, index) in listDataDetailData[index].acryPrintProducts" :key="index" class="w-100 d-flex border-dashed detail-cell">
                <div class="" style="width:15%"><img :src="p.previewImageUrl" class="img-fluid bg-secondary h-100" @click="imagePopup(p.previewImageUrl)"/></div>
                <div class="my-auto" style="width:15%"><span style="font-size:14px;">アクリープリント</span><br>{{ getSize(p.productId) }}</div>
                <div class="my-auto" style="width:20%">{{ p.quantity }}</div>
                <div class="my-auto" style="width:30%">{{ p.price }}円</div>
                <div class="my-1" style="width:30%"></div>
                <div class="d-flex flex-column justify-content-center" style="width:20%">
                  <div class="m-1" style="height:24px;">
                    <p class="link-text" @click="imagePopup(p.previewImageUrl)" style="cursor: pointer;">プレビュー</p>
                  </div>
                </div>
              </div>
              <!-- 注文商品 アクリープリント -->
              <div v-for="(p, index) in listDataDetailData[index].acryPrintSampleProducts" :key="index" class="w-100 d-flex border-dashed detail-cell">
                <div class="" style="width:15%"><img :src="p.previewImageUrl" class="img-fluid bg-secondary h-100" @click="imagePopup(p.previewImageUrl)"/></div>
                <div class="my-auto" style="width:15%"><span style="font-size:14px;">アクリープリントサンプル</span><br>{{ getSize(p.productId) }}</div>
                <div class="my-auto" style="width:20%">{{ p.quantity }}</div>
                <div class="my-auto" style="width:30%">{{ p.price }}円</div>
                <div class="my-1" style="width:30%"></div>
                <div class="d-flex flex-column justify-content-center" style="width:20%">
                  <div class="m-1" style="height:24px;">
                    <p class="link-text" @click="imagePopup(p.previewImageUrl)" style="cursor: pointer;">プレビュー</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 注文詳細 -->
          <div v-if="listDataDetail[index] && isTicketOrder(index)" class="w-100 border-dashed order-detail">
            <div class="w-100 d-flex p-4" style="font-size: 15px;">
              <div class="text-start ps-1" style="width:15%">コード発行数</div>
              <div class="text-start" style="width:85%">{{listDataDetailData[index].ticketProducts[0].quantity}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { User } from "@/js/User.js";
import Vue from "vue";
import { GetAcryProductPrice, GetAcryProductSizeText } from "@/js/Const.js";
import { FirebaseCommon } from "@/js/FirebaseCommon.js";
import { ProductData } from "@/js/ProductData.js";
import { EditDesignPreparation, DiscountRatio, ConvertSvgToPng } from "@/js/CommonFunc.js";
import { CenterViewState, RightViewState } from "@/js/Const.js";
import { Analytics } from "@/js/Analytics.js";
import { Big } from 'big.js';

export default {
  name: "CenterViewOrderHistory_Ap",
  props: {},
  data: function () {
    return {
      findType: "ORDER_DATE",
      fromDate: null,
      toDate: null,
      findOrderId: "",
      listData: [], // 
      listDataDetail: [],   // 詳細表示をしているかどうか
      listDataDetailData: [],
      currentOptionObj:null,
      currentDesignObj:null,
    };
  },
  computed: {},
  created: async function () {
    this.$store.commit("hideRightMenu");
    this.$store.commit("showLoading");
    // Firebase側からも情報を取得
    await this.$store.state.orderHistoryManager.update().catch((e) => {
      this.$handleError("058", e, { hideLoading: true });
    });
    await this.findAction();
    this.$store.commit("hideLoading");
  },
  components: {},
  methods: {
    isTicketOrder(index){
      if((this.listDataDetailData[index] && "ticketProducts" in this.listDataDetailData[index] && this.listDataDetailData[index].ticketProducts)){
        return this.listDataDetailData[index].ticketProducts.length != 0;
      }else{
        return false;
      }
    },
    imagePopup(imageUrl){
      this.$store.commit("showImagePreview", imageUrl);
    },
    async findAction() {
      this.$store.commit("showLoading");

      // サーバーからデータを取得
      this.listData = await User.getOrderHistory(
        this.findType,
        this.fromDate,
        this.toDate,
        this.findOrderId
      // error-check-ok: errorProcess は $handleError に統合（2026-09-14）
      ).catch((error) => {
        this.$handleError("059", error, { hideLoading: true });
        return [];
      });

      // 取得した注文データにFirebase分も追加
      this.listDataDetailData = [];
      this.listData.forEach((data, index) => {
        this.listDataDetailData[index] = this.$store.state.orderHistoryManager.getOrderHistoryData(
          data["order_id"]
        );
      });

      this.listDataDetail = [];
      this.listData.forEach((data, index) => {
        this.listDataDetail[index] = false;
      });
      this.$store.commit("hideLoading");
    },
    orderConfirmDate(ld) {
      if (ld["payment_date"]) {
        return ld["payment_date"];
      } else {
        return "お支払い情報";
      }
    },
    cellDetail(index) {
      // Firebaseから取ってくる
      // if (!this.listDataDetailData[index]) {
      //   this.listDataDetailData[
      //     index
      //   ] = this.$store.state.orderHistoryManager.getOrderHistoryData(
      //     this.listData[index]["order_id"]
      //   );
      // }

      Vue.set(this.listDataDetail, index, !this.listDataDetail[index]);
      // console.log(this.listDataDetailData[index]);
    },
    getShippingAddr(index){
      let addr = "〒";
      addr += this.listData[index]["shipping_zip01"] + '-' + this.listData[index]["shipping_zip02"] + '　';
      addr += this.listData[index]["shipping_addr01"] + ' ' + this.listData[index]["shipping_addr02"] + '　';
      addr += this.listData[index]["shipping_name01"] + this.listData[index]["shipping_name02"];
      return addr;
    },
    getShippingTel(index){
      let tel = this.listData[index]["shipping_tel01"] + '-';
      tel += this.listData[index]["shipping_tel02"] + '-';
      tel += this.listData[index]["shipping_tel03"];
      return tel;
    },
    getSize(productId) {
      return GetAcryProductSizeText(productId);
    },
    async receipt(orderId){

      let order = this.listData.find( e => e['order_id'] == orderId );

      if( order['status'] != 5 ){
        this.$store.commit("showMessage", "領収書は発送完了後に発行できるようになります。");
      }else{
        this.$store.commit("showLoading");
        await User.receiptDownload(orderId)
        this.$store.commit("hideLoading");
      }

    },
    preview(obj) {
      console.log(obj)
    },
    reorder(obj) {
      console.log(obj)
    },
    reorderOption(obj) {
      this.currentOptionObj = obj
      this.$store.commit("setReorderOptionCallback",this.reorderOptionProcess)
      this.$store.commit("setReorderOption",true)
    },
    reorderDesign(obj) {
      this.currentDesignObj = obj
      this.$store.commit("setReorderDesignCallback", {reorder:this.reorderDesignProcess, reedit:this.reeditDesignProcess})
      this.$store.commit("setReorderDesign",true)
    },
    reorderOptionProcess(num) {
      this.$store.commit("showLoading");

      let item = this.$store.state.optionManager.itemList
        .filter((item) => item.productId == this.currentOptionObj.productId)
        .shift();

      this.$store.state.cartManager
        .addCartOption(
          this.currentOptionObj.productId,
          item.title,
          num,
          this.currentOptionObj.designImageUrl
        )
        .catch((e) => {
          this.$handleError("060", e, { hideLoading: true });
          return;
        });

      Analytics.addToCartOption(this.currentOptionObj.productId, item.title, num, item.priceBase);

      this.$store.commit("hideLoading");

    },
    async reorderDesignProcess() {
      // プログレスバーを表示
      this.$store.commit("showProgress");
      this.$store.commit("setProgressMessages", [
        "デザインデータを作成中…",
        "しばらくお待ちください",
      ]);

      // デザインデータをまとめたZIPを取得
      let info = await FirebaseCommon.downloadDesignZip(this.currentDesignObj.designId);
      this.$store.commit("setProgress", 5);

      // サーバーから現在販売中の商品の情報を取得
      await this.$store.state.saleProductManager.update().catch((e) => {
        this.$handleError("061", e, { hideProgress: true });
        return;
      });
      this.$store.commit("setProgress", 10);

      // 販売中の商品リストからカートに追加する商品の情報を取得
      let saleProduct = this.$store.state.saleProductManager.getProduct(this.currentDesignObj.productId);
      this.$store.commit("setProgress", 15);

      // プロダクトデータを作成
      let p = new ProductData(
        saleProduct,
        saleProduct.productData["product_class_list2"][0]
      );

      // テキストの情報を設定
      await p.createDataForJson( info, this.currentDesignObj.designId );

      // デザイン画像とカットライン画像をダウンロードしvuexに保存
      await EditDesignPreparation(this.currentDesignObj.designId, this.currentDesignObj.productId, info.productJson.isShareCodeDraft, this.$store );
      this.$store.commit("setProgress", 20);

      // vuexに保存されている画像を設定
      await p.canvasDatas[0].setBaseImage(
        this.$store.state.designImageFile,
        this.$store.state.designImageURL,
        (info.productJson.isShareCodeDraft)?this.$store.state.scCutlineImageFile:this.$store.state.cutlineImageFile,
        this.$store.state.frameCutlineImageURL
      );
      this.$store.commit("setProgress", 25);

      let self = this;
      await this.$store.state.cartManager.addCartProduct(p, false, function(progress){
        self.$store.commit("setProgress", 25 + (75 / 100 * progress));
      }).catch((e) => {
        this.$handleError("062", e, { hideProgress: true });
        return;
      });

      // 割引後の単価を計算
      const productPrice = GetAcryProductPrice(this.currentDesignObj.productId);
      const totalQuantity = parseInt(this.$store.state.cartManager.getCartProductQuantity(this.currentDesignObj.productId));
      const ratio = DiscountRatio(totalQuantity);
      // 丸め誤差が出ないようにライブラリを使用して計算
      const priceBase = new Big(productPrice.priceBase);
      const priceRatio = new Big(100-ratio).div(100);
      const discountPrice = priceBase.times(priceRatio);

      const productSizeTxt = GetAcryProductSizeText(this.currentDesignObj.productId);
      Analytics.addToCartAcrylic(this.currentDesignObj.productId, saleProduct.productName, p.quantity, discountPrice.toNumber(), productSizeTxt );

      this.$store.commit("hideProgress");
      this.$store.commit("showMessage", "カートに追加しました");
    },
    async reeditDesignProcess() {
      this.$store.commit("showLoading");

      let info = await FirebaseCommon.downloadDesignZip(this.currentDesignObj.designId);

      await this.$store.state.saleProductManager.update().catch((e) => {
        this.$handleError("063", e, { hideLoading: true });
        return;
      });

      let saleProduct = this.$store.state.saleProductManager.getProduct(this.currentDesignObj.productId);

      let p = new ProductData(
        saleProduct,
        saleProduct.productData["product_class_list2"][0]
      );
      this.$store.commit("setSelectProductId", this.currentDesignObj.productId);
      await p.createDataForJson( info, this.currentDesignObj.designId );
      await EditDesignPreparation(this.currentDesignObj.designId, this.currentDesignObj.productId, info.productJson.isShareCodeDraft, this.$store );
      await p.canvasDatas[0].setBaseImage(
        this.$store.state.designImageFile,
        this.$store.state.designImageURL,
        (info.productJson.isShareCodeDraft)?this.$store.state.scCutlineImageFile:this.$store.state.cutlineImageFile,
        this.$store.state.frameCutlineImageURL
      );

      // プレビューの設定
      this.$store.commit('designPreview/reset');
      this.$store.commit('designPreview/set', { key: 'selectProductId', value: this.currentDesignObj.productId })
      this.$store.commit('designPreview/set', { key: 'designImageURL', value: URL.createObjectURL(this.$store.state.designImageFile) })

      if( info.productJson.isShareCodeDraft ) {
        this.$store.commit('designPreview/set', { key: 'cutlineImagePngURL', value: this.$store.state.scCutlineImageURL });
      }else{
        let pngCutline = await ConvertSvgToPng(this.$store.state.cutlineImageURL, this.currentDesignObj.productId);
        this.$store.commit('designPreview/set', { key: 'cutlineImagePngURL', value: pngCutline });
      }

      this.$store.commit("addProduct", p);
      this.$store.commit("selectCanvasData", p.canvasDatas[0]);
      this.$store.commit("hideLoading");

      // 編集用のUIに変更
      this.$store.commit('setCenterViewState', CenterViewState.Edit);
      this.$store.commit('setRightViewState', RightViewState.Edit);

      this.$store.commit("hideLoading");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.input-field{
  height: 100%;
  border-radius: 100px;
  border: 1px solid $primary-main-color;
}

.scroll {
  overflow-y: scroll;
}

input[type="date"] {
  position: relative;
}

input[type="date"]::-webkit-calendar-picker-indicator {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: auto;
  height: auto;
  background: transparent;
  z-index: 1;
}

input[type="date"]::after {
  content: '';
  background-image: url('~@/assets/acrypro/ico_calendar.svg');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: 0 0;
  width: 30px;
  height: 30px;
  position: absolute;
  top: 50%;
  left: 17px;
  transform: translateY(-50%);
}

// 検索結果のセル
.cell{
  height: 120px;
  padding: 16px 0px;
  border-bottom: 1px ;
}

// 各商品のセル
.detail-cell{
  height: 144px;

}

.cell-border{
  border-bottom: 1px solid $border-sub-color;
}

.border-dashed{
  border-top: 1px dashed $border-sub-color;
}

.btn-size{
  height: 40px;
}

.order-detail{
  background: $background-gray-color;
}

.link-text{
  font-family: 'Noto Sans JP';
  font-weight: bold;
  color: $primary-main-color;
}

.disable-ui{
  opacity: 0.5;
}

</style>
